import TextInput from "@/components/textfields";
import { Box, styled, Typography } from "@mui/material";

export const StyledTextInput = styled(TextInput)({
  marginBottom: "16px",
});

export const StyledBox = styled(Box)({
  padding: "8px 16px",
});

export const HeadingText = styled(Typography)({
  fontWeight: 500,
  fontSize: "16px",
});
